var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharelinkMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#007293"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16497_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 21.2793L13.1286 25.8222C12.9947 25.955 12.8884 26.113 12.8159 26.287C12.7434 26.4611 12.7061 26.6479 12.7061 26.8364C12.7061 27.025 12.7434 27.2118 12.8159 27.3858C12.8884 27.5599 12.9947 27.7179 13.1286 27.8507L16.1572 30.8793C16.29 31.0132 16.448 31.1195 16.6221 31.192C16.7962 31.2645 16.9829 31.3019 17.1715 31.3019C17.3601 31.3019 17.5468 31.2645 17.7209 31.192C17.895 31.1195 18.053 31.0132 18.1858 30.8793L22.7286 26.2936",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2858 22.7364L30.8286 18.1936C30.9625 18.0608 31.0688 17.9028 31.1413 17.7287C31.2139 17.5546 31.2512 17.3679 31.2512 17.1793C31.2512 16.9907 31.2139 16.804 31.1413 16.6299C31.0688 16.4558 30.9625 16.2978 30.8286 16.165L27.8429 13.1364C27.7101 13.0025 27.5521 12.8963 27.378 12.8237C27.2039 12.7512 27.0172 12.7139 26.8286 12.7139C26.64 12.7139 26.4533 12.7512 26.2792 12.8237C26.1051 12.8963 25.9471 13.0025 25.8143 13.1364L21.2715 17.7222",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8571 19.1506L19.1428 24.8649",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16497_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12.0078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharelinkMobile);
export default __webpack_public_path__ + "static/media/SharelinkMobile.2609cc9986fae17ad6028a8e45cc8227.svg";
export { ForwardRef as ReactComponent };